import { render } from "./EtatColisParCasier.vue?vue&type=template&id=131e2acc&ts=true"
import script from "./EtatColisParCasier.vue?vue&type=script&lang=ts"
export * from "./EtatColisParCasier.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__